<template>
    <div>
        <div
            v-if="loading"
            class="text-center p-4">
            <font-awesome-icon
                icon="circle-notch"
                spin
                size="2x" />
        </div>
        <div
            v-else
            style="word-break: break-word">
            <EventEntryDetailsGeneral
                v-if="event"
                class="mt-2 mx-2"
                :event="event"
                :closeable="closeable"
                :hide-categories="hideCategories"
                @close="$emit('showMainPage')" />
            <div
                v-else
                class="text-center p-4">
                <h2 v-if="iFrameType==='events'">
                    <font-awesome-icon
                        icon="times"
                        class="mx-2" />
                    {{ $t('iFrame.noSuchEvent') }}
                </h2>
                <h2 v-if="iFrameType==='appointments'">
                    <font-awesome-icon
                        icon="times"
                        class="mx-2" />
                    {{ $t('iFrame.noSuchAppointment') }}
                </h2>
            </div>
            <div
                v-if="closeable"
                class="d-flex justify-content-end mt-4">
                <base-button
                    type="primary"
                    outline
                    @click="$emit('showMainPage')">
                    <span v-if="backButtonLabel">{{ backButtonLabel }}</span>
                    <span v-else-if="iFrameType==='events'">{{ $t('iFrame.moreEvents') }}</span>
                    <span v-else-if="iFrameType==='appointments'">{{ $t('iFrame.moreAppointments') }}</span>
                </base-button>
            </div>
        </div>
    </div>
</template>

<script>
import EventEntryDetailsGeneral
    from "@/components/pages/eventIFrame/EventEntry/EventEntryTiles/EventEntryDetailsGeneral";
export default {
    name: "IFrameSingleEvent",
    components: {EventEntryDetailsGeneral},
    props: {
        event: {
            type: Object,
            default: null
        },
        iFrameType: {
            type: String,
            default: 'events'
        },
        loading: {
            type: Boolean,
            default: false
        },
        backButtonLabel: {
            type: String,
            default: null
        },
        closeable: {
            type: Boolean,
            default: false
        },
        hideCategories: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.$emit('hook:mounted')
    }
}
</script>

<style scoped>

</style>
